import styled from 'styled-components';
import { theme } from '~/styles/themes';

export const DetailsContainer = styled.div`
  border-bottom: 1px solid #f2f3f0;
  margin: 1em 0;
  padding-bottom: 1em;
`;

export const SliderFooter = styled.div`
  margin: 1.5em 0;
  color: ${theme.colors.secondaryBlack};
  span {
    vertical-align: baseline;
  }
`;
